import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors } from '../../../theme';
import { Row as GridRow } from '../../common/Grid';
import { Drawer as AntDrawer } from 'antd';
import { breakpointsMax } from '../../../theme';

export const SessionDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 500px;
`;

export const SessionTopDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
`;

export const Statistic = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: 0.55rem 0.3rem;
  margin: 0.5rem 0;
  border-radius: 7px;
  @media (min-width: 768px) {
    width: 100%;
  }
`;

export const StatisticItems = styled.div`
  width: 33%;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  padding: 0 0.5rem;
`;

export const StatisticName = styled.span`
  display: block;
  color: ${colors.blackSecondary};
  text-align: center;
  margin: 0.8rem 0 0 0;
  font-size: 0.9rem;
  @media (min-width: 768px) {
    font-size: 1rem;
  }
`;

export const StatisticValue = styled.span`
  display: block;
  color: ${colors.black};
  text-align: center;
  padding: 0.3rem;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: capitalize;
  @media (min-width: 768px) {
    font-size: 1rem;
    padding: 0.9rem 0;
  }
`;

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FeedbackHeaderDiv = styled(HeaderDiv)`
  align-items: center;
`;

export const IncompleteBadge = styled.span`
  color: ${colors.primary};
  font-weight: 600;
  font-size: 14px;
  line-height: 160%;
`;

export const TrainersName = styled(Link)`
  color: ${colors.black};
  font-weight: 400;
  text-decoration: none;
  text-transform: capitalize;
  padding-left: 0.7rem;
`;

// NEW COMPONENTS

export const SubDetails = styled.div`
  padding: 0.75rem 0 0.5rem 0;
  color: ${colors.blackSecondary};
  display: flex;
`;

export const SubDetailsTitle = styled.p`
  width: 25%;
  margin: 0;
  padding-right: 1rem;
`;

export const SubDetailsContent = styled.p`
  margin-left: 1rem;
  color: ${colors.black};
  font-weight: 400;
  text-decoration: none;
  font-size: 0.95rem;
  margin: 0;
`;

export const DrawerLink = styled.p`
  margin: 0;
  color: ${colors.darkGray};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 95%;
  margin: 0 auto;
  align-items: center;
  color: ${colors.primary};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  &:hover p {
    font-weight: 500;
    color: ${colors.primary};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }

  ${({ enabled }) =>
    enabled
      ? ''
      : `& * {
        pointer-events: none;
      }`}
`;

export const Edit = styled.p`
  margin-left: auto;
  margin-right: 1rem;
  font-family: 'museo-sans', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: prim
  color: ${colors.primary};
  cursor: pointer;
  &:hover {
    font-weight: 500;
    color: ${colors.secondary};
  }
`;

export const DrawerContentWrapper = styled.div`
  max-width: 450px;
  margin: 0 auto;
  text-align: center;
  background: #f7f8f9;
  text-align: center;
  padding-top: 3rem;

  .ant-checkbox-group .ant-checkbox-group-item {
    display: block;
    margin: 1rem 0;
  }
`;

export const CheckboxWrapper = styled.div`
  width: 100%;
  text-align: left;
`;

export const TableWrapper = styled.div`
  background: #fff;
  max-width: 500px;
  margin: 0 auto;
  margin-top: 2rem;
`;

export const TableHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 95%;
  margin: 0 auto;
  align-items: center;
`;

export const Text = styled.p`
  margin: 1rem 0;
  font-weight: 700;
`;

export const EmailWrapper = styled.div`
  background: #fff;
  max-width: 600px;
  margin: 0 auto;
  margin-top: 4rem;
  padding: 2rem 1rem;

  @media (min-width: 768px) {
    padding: 2rem;
  }
`;

export const EmailText = styled.p`
  font-family: 'museo-sans', sans-serif;
  font-weight: 300;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 0rem;
  color: ${({ black }) => (black ? 'black' : 'inherit')};
`;

export const BoldSpan = styled.span`
  font-weight: 500;
  color: ${({ black }) => (black ? 'black' : 'inherit')};
`;

export const BackWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 80px;
  cursor: pointer;
  margin: 2rem 20px;
  font-weight: 500;
  font-size: 18px;
  cursor: pointer;

  @media ${breakpointsMax.tablet} {
    margin: 10px 0 20px 0;
  }
`;

export const FormWrapper = styled.div`
  max-width: 500px;
  margin: 0 auto;
  margin-top: 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SelecetWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
`;

export const IconsWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  min-width: 90px;
  margin-bottom: 5px;
`;

export const WhiteWrapper = styled.div`
  display: flex;
  background: #ffffff;
  width: 100%;
  margin: 0 auto;
  padding: 1rem;
  flex-direction: column;
`;

export const ViewMore = styled.button`
  background: none;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  align-items: center;
  color: #000000;
  margin: 0 auto;
  display: block;
  border: none;
  cursor: pointer;
  margin-top: 1rem;
`;

export const StatHeaderRow = styled(GridRow)`
  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.colors.midPrimary};
  padding-bottom: ${({ theme }) => theme.spacings[3]};
  padding-top: ${({ theme }) => theme.spacings[4]};
`;

export const DrawerWrapper = styled.div`
  padding-left: ${({ theme }) => theme.spacings[5]};

  @media ${breakpointsMax.tablet} {
    padding-left: 0;
  }
`;

export const Drawer = styled(AntDrawer)`
  min-height: 100%;
  background: ${({ theme }) => theme.colors.white};

  .ant-drawer-close {
    display: none;
  }
`;

export const WarningWrapper = styled.div`
  margin-bottom: 48px;
`;
export const WarningText = styled.div`
  display: flex;
  align-items: start;
`;

export const EmailList = styled.ul`
  color: ${({ theme }) => theme.colors.primary};
  margin-top: 10px;
  margin-left: 58px;
  li {
    margin-bottom: 8px;
  }
`;

export const IconWrapper = styled.div`
  display: inline-block;
  margin-right: 8px;
`;
